/**
 * @param props
 * @param props.isAvailable
 * @returns {boolean}
 */
const isDisabledByIdVariantSelectorUtil = ({
  isAvailable,
  hasSampledAndRated
}) => {
  return !!(!isAvailable || hasSampledAndRated)
}

export default isDisabledByIdVariantSelectorUtil
